import { graphQlClient } from '@config/graphqlClient';
import TaskCategoryGraphQL from '@graphql/taskCategory.queries';
import {
  CreateTaskCategoryResponse,
  DeleteTaskCategoryResponse,
  GetActiveTaskCategoriesResponse,
  GetTaskCategoriesResponse,
  TaskCategory,
  TaskCategoryCreateInput,
  TaskCategoryUpdateInput,
  UpdateTaskCategoryResponse,
} from '@models/taskCategory.model';

export const taskCategoryService = {
  async getTaskCategories(): Promise<TaskCategory[]> {
    const data: GetTaskCategoriesResponse = await graphQlClient.request(
      TaskCategoryGraphQL.queries.getTaskCategories,
    );
    return data.getTaskCategories || [];
  },

  async getActiveTaskCategories(): Promise<TaskCategory[]> {
    const data: GetActiveTaskCategoriesResponse = await graphQlClient.request(
      TaskCategoryGraphQL.queries.getActiveTaskCategories,
    );
    return data.getActiveTaskCategories || [];
  },

  async createTaskCategory(input: TaskCategoryCreateInput): Promise<TaskCategory> {
    const data: CreateTaskCategoryResponse = await graphQlClient.request(
      TaskCategoryGraphQL.mutations.createTaskCategory,
      { taskCategory: input },
    );
    if (!data?.createTaskCategory) throw new Error('Failed to create task category');
    return data.createTaskCategory;
  },

  async updateTaskCategory(input: TaskCategoryUpdateInput): Promise<TaskCategory> {
    if (!input.taskCategoryId) throw new Error('taskCategoryId is required');
    const data: UpdateTaskCategoryResponse = await graphQlClient.request(
      TaskCategoryGraphQL.mutations.updateTaskCategory,
      { taskCategory: input },
    );
    if (!data?.updateTaskCategory) throw new Error('Failed to update task category');
    return data.updateTaskCategory;
  },

  async deleteTaskCategory(taskCategoryId: string): Promise<{ affected: number }> {
    if (!taskCategoryId) throw new Error('taskCategoryId is required');
    const data: DeleteTaskCategoryResponse = await graphQlClient.request(
      TaskCategoryGraphQL.mutations.deleteTaskCategory,
      { taskCategoryId },
    );
    return data.deleteTaskCategory;
  },
};

export default taskCategoryService;
